import { TextField } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import React, {Fragment, useEffect} from "react";
import _ from "lodash";
import {isValueEmpty} from "_helpers";
import styles from "./styles/Styles.module.css";

export default function BasicSelect({input, label, defaultValue, placeholder, options, id, name, onChange, handleFormSelectChange = (val) => {}, meta}) {
  const touched = _.get(meta, 'touched');
  const error = _.get(meta, 'error');
  const warning = _.get(meta, 'warning');
  const hasError = touched && !_.isEmpty(error);
  const placeholderValue = isValueEmpty(defaultValue) ? 'none' : defaultValue;
  const [item, setItem] = React.useState(placeholderValue);
  const [selectOptions, setSelectOptions] = React.useState(options);

    useEffect(() => {
        if (!_.isEqual(_.sortBy(options || []), _.sortBy(selectOptions || []))) {
            setSelectOptions(options);
            handleFormSelectChange(placeholderValue);
        }
    }, [options, selectOptions, handleFormSelectChange, placeholderValue]);

    useEffect(() => {
        const externalValue = isValueEmpty(input?.value) ? "none" : input.value;
        if (externalValue !== item) {
            setItem(externalValue);
        }
    }, [input?.value]);

  const handleChange = (event) => {
    if (typeof onChange === 'function') {
      onChange(event);
    }
    setItem(event.target.value);
  };

    const handleRenderValue = (selected) => {
        const res = options.find(item => item.id === selected);
        return res ? res.name : placeholder;
    };

  const renderMenuItems = (item) => {
    return <MenuItem
      key={item.id}
      input={input}
      value={item.id}
      sx={{fontSize: '16px'}}>
      {item.name}
    </MenuItem>
  };

  return(
    <Fragment>
      <TextField className={ (hasError || warning) ? styles.basicSelectTextFieldError : styles.basicSelectTextField }
                 InputProps={{ classes: { root: styles.basicSelectTextField } }}
                 inputProps={{ classes: { icon: styles.basicSelectTextFieldIcon } }}
                 SelectProps={{
                   value: item,
                   onChange: handleChange,
                   renderValue: handleRenderValue
                 }}
                 id={id}
                 name={name}
                 label={label}
                 variant="outlined"
                 select
                 {...input}
                 error={ hasError }>
        <MenuItem value={placeholderValue} disabled sx={{display: 'none'}}>
          {placeholder}
        </MenuItem>
        { options ? options.map(renderMenuItems) : <MenuItem/> }
      </TextField>
    </Fragment>
  )
}